import { Tooltip } from '@orbitalwatch/design';
import { Icons } from './icons';
import { lockBadgeLabel } from './lockLabel';

export interface LockBadgeProps {
    /** `own`: the page carries the lock (full glyph); `inherited`: it sits under a locked ancestor (lighter glyph). */
    state: 'own' | 'inherited';
    /** Title of the page that carries the lock (inherited: the tooltip says "Locked through “X”"). */
    by?: string;
    /** Overrides the tooltip text (the lock reason, a detailed sentence). */
    reason?: string;
    /** `sm` 14 px (tree rows, tables, default), `md` 16 px (page header). */
    size?: 'sm' | 'md';
    className?: string;
}

/**
 * DS gap: the one lock glyph of Ark (tree rows, page header, tables). The library `Tree` only offers a "Locked" chip with
 * no own / inherited distinction; this is the kit's lock stroke glyph, full for own locks and lighter for inherited ones,
 * with the reason as a library `Tooltip` (`ds.css` "lock badge").
 */
export function LockBadge(props: LockBadgeProps) {
    const label = lockBadgeLabel(props);
    const size = props.size === 'md' ? 16 : 14;
    return (
        <Tooltip content={label} wrapTrigger>
            <span
                className={['ark-lock-badge', `is-${props.state}`, props.className].filter(Boolean).join(' ')}
                role="img"
                aria-label={label}
            >
                <Icons.lock size={size} />
            </span>
        </Tooltip>
    );
}
